// Student/parent misc native screens (school blog, notification pages, news
// approval OTP, pro upgrade, parenting welcome/contact). Every string carries
// the SP_MISC_ prefix so it stays globally unique across saga watchers.
export const SP_MISC_GET_SCHOOL_BLOG_POSTS = 'SP_MISC_GET_SCHOOL_BLOG_POSTS'
export const SP_MISC_GET_SCHOOL_BLOG_POST = 'SP_MISC_GET_SCHOOL_BLOG_POST'
export const SP_MISC_POST_SCHOOL_BLOG_COMMENT = 'SP_MISC_POST_SCHOOL_BLOG_COMMENT'
export const SP_MISC_GET_NOTIFICATION_DETAIL = 'SP_MISC_GET_NOTIFICATION_DETAIL'
export const SP_MISC_GET_NEWS_APPROVAL_OTP = 'SP_MISC_GET_NEWS_APPROVAL_OTP'
export const SP_MISC_SEND_NEWS_APPROVAL_OTP = 'SP_MISC_SEND_NEWS_APPROVAL_OTP'
export const SP_MISC_VERIFY_NEWS_APPROVAL_OTP = 'SP_MISC_VERIFY_NEWS_APPROVAL_OTP'
export const SP_MISC_GET_PRO_UPGRADE = 'SP_MISC_GET_PRO_UPGRADE'
export const SP_MISC_GET_PARENTING_WELCOME = 'SP_MISC_GET_PARENTING_WELCOME'
export const SP_MISC_SEND_PARENTING_CONTACT = 'SP_MISC_SEND_PARENTING_CONTACT'
export const SP_MISC_GET_CHILD_PROFILE = 'SP_MISC_GET_CHILD_PROFILE'
export const SP_MISC_GET_OWN_PROFILE = 'SP_MISC_GET_OWN_PROFILE'
